var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInternational(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.504 16C4.16802 17.3067 3.99867 18.6507 4 20C4 21.38 4.176 22.72 4.504 24H10.2C9.93266 21.34 9.93266 18.66 10.2 16H4.504ZM6.14 12H10.832C11.364 9.566 12.132 7.386 13.074 5.572C10.1707 6.97135 7.75492 9.21086 6.14 12ZM35.496 16H29.8C30.0673 18.66 30.0673 21.34 29.8 24H35.496C36.1691 21.3758 36.1691 18.6242 35.496 16ZM33.86 12C32.2451 9.21086 29.8293 6.97135 26.926 5.572C27.87 7.386 28.636 9.566 29.168 12H33.86ZM14.224 16C14.0751 17.3281 14.0004 18.6635 14 20C14 21.37 14.076 22.71 14.224 24H25.776C26.0766 21.3418 26.0766 18.6582 25.776 16H14.224ZM14.94 12H25.06C24.6954 10.4968 24.1704 9.03708 23.494 7.646C22.238 5.136 20.894 4 20 4C19.106 4 17.762 5.136 16.506 7.646C15.876 8.91 15.346 10.38 14.94 12ZM6.14 28C7.75492 30.7891 10.1707 33.0286 13.074 34.428C12.13 32.614 11.364 30.434 10.832 28H6.14ZM33.86 28H29.168C28.636 30.434 27.868 32.614 26.926 34.428C29.8293 33.0286 32.2451 30.7891 33.86 28ZM14.94 28C15.346 29.62 15.876 31.09 16.506 32.354C17.762 34.864 19.106 36 20 36C20.894 36 22.238 34.864 23.494 32.354C24.124 31.09 24.654 29.62 25.06 28H14.94ZM20 40C8.954 40 0 31.046 0 20C0 8.954 8.954 0 20 0C31.046 0 40 8.954 40 20C40 31.046 31.046 40 20 40Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternational);
export default __webpack_public_path__ + "static/media/international.4d8a1e579cbef28d3a9be95296e48a71.svg";
export { ForwardRef as ReactComponent };